import { FilterChip } from '@marqvision/shared';
import { MarqCommonEnumsAiClientTagEnum } from '~/swagger/data-contracts';
import { useLogger } from '~/hooks';
import { getListingTabGroup } from '~/utils';
import { ResponsiveProps } from '~/components/Responsive/@types';
import { useGetFilterParams, usePathParams } from './@hooks';
import { TAG_FILTER_LABEL } from './@constants';

export const LowPriceFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const { requestFilterParams, setParams } = useGetFilterParams();
  const { low_price_filter: lowPrice } = requestFilterParams;
  const { page, listingStatus } = usePathParams();
  const { amplitudeLogging } = useLogger();

  const handleChange = () => {
    const newState = !lowPrice;
    if (newState) {
      amplitudeLogging('applied filter', {
        Type: 'low price',
        Channel: page,
        Page: getListingTabGroup(listingStatus),
      });
    }
    setParams({
      low_price: !lowPrice,
    });
  };

  return (
    <FilterChip
      size={size}
      type="toggle"
      selected={!!lowPrice}
      label={TAG_FILTER_LABEL[MarqCommonEnumsAiClientTagEnum.LowPrice]}
      onClick={handleChange}
    />
  );
};
